module.exports = __webpack_public_path__ + "e9954a768961349cd80e6a71658e7e7f.MP3";